import * as THREE from 'three';

export const DOWN = Object.freeze(new THREE.Vector3(0, -1, 0));
export const UP = Object.freeze(new THREE.Vector3(0, 1, 0));
export const FORWARD = Object.freeze(new THREE.Vector3(0, 0, -1));
export const BACK = Object.freeze(new THREE.Vector3(0, 0, 1));
export const LEFT = Object.freeze(new THREE.Vector3(-1, 0, 0));
export const RIGHT = Object.freeze(new THREE.Vector3(1, 0, 0));
export const ZERO_VECTOR3 = Object.freeze(new THREE.Vector3(0, 0, 0));
